var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSides(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 200,
    viewBox: "0 0 100 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0L0 100L25 75L50 0Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 100L50 200L25 125L0 100Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 200L100 100L75 125L50 200Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100 100L50 0L75 75L100 100Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSides);
export default __webpack_public_path__ + "static/media/sides.a926e79f380b47e420cf496e18393617.svg";
export { ForwardRef as ReactComponent };